import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    children: ReactNode;
    text?: string; // only for storybook
    className?: string;
}

const Heading2: FC<Props> = ({ children, text, className }) => {
    return <h2 className={cn('', className)}>{text ?? children}</h2>;
};

export default Heading2;
